'use client';

import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';
import { useCart } from '@weareconceptstudio/cart';

// CatalogTemplate reads `document` during render (not inside an effect), which
// crashes SSR even in a 'use client' component. Load it client-only.
const CatalogTemplate = dynamic(() => import('@weareconceptstudio/ecommerce/v1').then((m) => m.CatalogTemplate), {
	ssr: false,
});

const isProductAvailableForBranch = (product, branchId) => {
	const ids = product.takeaway_branch_ids;
	if (!Array.isArray(ids) || ids.length === 0) return true;
	return ids.includes(Number(branchId));
};

const filterCategoryProducts = (category, branchId) => {
	const filteredProducts = category.products?.filter((p) => isProductAvailableForBranch(p, branchId)) ?? [];

	const filteredChildren =
		category.children
			?.map((child) => filterCategoryProducts(child, branchId))
			.filter((child) => child.products?.length > 0 || child.children?.length > 0) ?? [];

	return { ...category, products: filteredProducts, children: filteredChildren };
};

const BranchCatalogTemplate = ({ categories, ...rest }) => {
	const { checkoutData } = useCart();
	const branchId = checkoutData?.fulfillmentType === 'takeaway' ? checkoutData?.fulfillmentBranchId : null;

	const filteredCategories = useMemo(() => {
		if (!branchId || !categories) return categories;
		return categories
			.map((cat) => filterCategoryProducts(cat, branchId))
			.filter((cat) => cat.products?.length > 0 || cat.children?.some((c) => c.products?.length > 0 || c.children?.length > 0));
	}, [categories, branchId]);

	return (
		<CatalogTemplate
			key={branchId || 'all'}
			categories={filteredCategories}
			{...rest}
		/>
	);
};

export default BranchCatalogTemplate;
